import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import usePageSeo from '../hooks/usePageSeo';
import { getGuideBySlug } from '../data/knowledgeAcademy';
import UAEVATGuide from './academy/UAEVATGuide';
import UAECorporateTaxGuide from './academy/UAECorporateTaxGuide';
import UAECustomsDutyGuide from './academy/UAECustomsDutyGuide';
import UAEGoAMLComplianceGuide from './academy/UAEGoAMLComplianceGuide';
import UAEVATTOGCGuide from './academy/UAEVATTOGCGuide';
import UAEFreeZonesDesignatedZonesGuide from './academy/UAEFreeZonesDesignatedZonesGuide';
import UAEVATReverseChargeMetalScrapGuide from './academy/UAEVATReverseChargeMetalScrapGuide';
import UAEEInvoicingGuide from './academy/UAEEInvoicingGuide';
import UAEFIURegulation1of2026Guide from './academy/UAEFIURegulation1of2026Guide';

/**
 * Slug-based dispatcher for every WPAA Academy article.
 * Adding a new guide is: create a new file under /pages/academy/ +
 * register its slug in /data/knowledgeAcademy.js + add one branch here.
 */

const GUIDE_MAP = {
  'uae-vat-guide-2026': UAEVATGuide,
  'uae-corporate-tax-guide-2026': UAECorporateTaxGuide,
  'uae-customs-duty-guide': UAECustomsDutyGuide,
  'uae-goaml-aml-compliance-guide': UAEGoAMLComplianceGuide,
  'vat-transfer-business-uae-togc': UAEVATTOGCGuide,
  'uae-free-zones-vs-designated-zones-tax': UAEFreeZonesDesignatedZonesGuide,
  'uae-vat-reverse-charge-metal-scrap-vatp047': UAEVATReverseChargeMetalScrapGuide,
  'uae-e-invoicing-phases-pint-ae-guide': UAEEInvoicingGuide,
  'uae-fiu-regulation-1-2026-suspicious-transactions-freezing-funds': UAEFIURegulation1of2026Guide
};

const KnowledgeAcademyArticle = () => {
  const { slug } = useParams();
  const guide = getGuideBySlug(slug);
  const Component = GUIDE_MAP[slug];

  usePageSeo({
    title: guide ? guide.metaTitle : 'Guide Not Found | WPAA Academy',
    description: guide ? guide.metaDescription : 'This WPAA Academy guide is not published yet. Browse the hub for available topics.',
    path: `/knowledge-academy/${slug || ''}`
  });

  if (Component) return <Component />;

  return (
    <div className="min-h-screen pt-32 pb-20 px-4 text-center" data-testid="ka-article-not-found">
      <div className="max-w-lg mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Guide not found</h1>
        <p className="text-gray-600 mb-6">
          This WPAA Academy guide isn&apos;t published yet. Browse our hub for available topics.
        </p>
        <Link to="/knowledge-academy">
          <Button className="bg-teal-600 hover:bg-teal-700 text-white">Back to WPAA Academy</Button>
        </Link>
      </div>
    </div>
  );
};

export default KnowledgeAcademyArticle;
